import React, { useEffect } from "react";
import styled from "styled-components";
import Slider from "react-slick";
import Container from "../../UI/Container";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { NavLink } from "react-router-dom";
import Card from "../Card";
import { useState } from "react";
import j from "../../images/i.webp";

function MainSlider({ data }) {
  const settings = {
    dots: true,
    fade: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplaySpeed: 3000,
    // autoplay: true,
    arrows: false,
  };

  return (
    <Container>
      <Wrapper>
        <Slider {...settings}>
          {data.slice(0, 3).map((i) => (
            <div>
              <div className="slide-item flex">
                <div className="content flex column">
                  <NavLink to={"/"} className="tag">
                    {i.post_tags[0]}
                  </NavLink>
                  <NavLink to={`/posts/${i.id}`}>
                    <h1 className="title">{i.post_title}</h1>
                  </NavLink>
                  <p className="flex">
                    Published at:{" "}
                    {new Date(i.post_date).toDateString().slice(3, 100)}
                    <br />
                    {/* <span style={{ margin: "0 8px" }}>-</span> */}
                    Views: {i.post_views_count}
                  </p>
                </div>
                <div className="image">
                  <img
                    src={
                      "https://flexiblog-science.netlify.app/static/cf1ca7499cd89ebe22a06ff4a90d433e/f47df/image.webp"
                    }
                  />
                </div>
              </div>
            </div>
          ))}
        </Slider>
        <div className="devider"></div>
        <div className="cards">
          {data.slice(3, 6).map((i) => (
            <Card data={i} />
          ))}
        </div>
        <div className="devider"></div>
      </Wrapper>
    </Container>
  );
}

export default MainSlider;

const Wrapper = styled.div`
  .content {
    width: 100%;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    @media (max-width: 991px) {
      padding-left: 12px;
      padding-bottom: 24px;
      h1 {
        font-size: 24px;
      }
    }
    p {
      justify-content: flex-start;
      &.flex {
        @media (max-width: 991px) {
          display: none;
        }
      }
    }
  }
  .slick-active {
    z-index: 9;
  }
  .slide-item {
    overflow: hidden;
    display: flex;
    justify-content: space-between;
    align-items: stretch;
    flex-direction: row;
    gap: 100px;
    @media (max-width: 991px) {
      flex-direction: column-reverse;
      gap: 40px;
    }
    .image {
      position: relative;
      margin-top: 10px;
      margin-bottom: 10px;
      margin-right: 10px;
      flex: 0 0 360px;
      @media (max-width: 991px) {
        flex: 0 0 100%;
      }
      img {
        width: 100%;
        aspect-ratio: 6/8;
        object-fit: cover;
        object-position: center;
        height: auto;
        overflow: hidden;
        @media (max-width: 991px) {
          aspect-ratio: unset;
          height: 300px;
          width: calc(100% - 10px);
          left: 10px;
        }
      }
      &:after {
        top: -0.5rem;
        left: -0.5rem;
        width: 66.666667%;
        height: 66.666667%;
        content: "";
        background-color: var(--theme-ui-colors-omegaLight, #e2e8f0);
        position: absolute;
        border-radius: 0.5rem 0;
        z-index: 1;
        @media (max-width: 991px) {
          left: -1rem;
        }
      }
      &:before {
        content: "";
        background-color: var(--theme-ui-colors-omegaLight, #e2e8f0);
        position: absolute;
        z-index: 1;
        bottom: -0.5rem;
        right: -0.5rem;
        width: 80px;
        height: 80px;
        border-radius: 3rem 0;
        @media (max-width: 991px) {
          border-radius: 2.4rem 0;
        }
      }
    }
    img {
      border-radius: 0.5rem 3rem 3rem;
      z-index: 2;
      position: relative;
      @media (max-width: 991px) {
        border-radius: 0.5rem 2rem 2rem;
      }
    }
  }
  .slick-dots {
    text-align: left;
    @media (max-width: 991px) {
      text-align: center;
    }
    li {
      button::before {
        font-size: 12px;
      }
    }
  }
  .cards {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    grid-gap: 16px;
    grid-auto-rows: auto;
    @media (max-width: 991px) {
      display: none;
    }
    & > div {
      height: 100%;
      transition: all 0.3s;
      & > div {
        height: 100%;
      }
      &:hover {
        /* transform: translateY(-5px); */
      }
    }
  }
  a h1 {
    color: #2d3748;
    trasnsition: all 0.3s;
    &:hover {
      color: #078cca;
    }
  }
  h1 {
    font-family: "Libre Baskerville", sans-serif;
    font-weight: bold;
    line-height: 1.33;
    height: auto;
    font-size: 3rem;
    margin-top: 16px;
    z-index: unset;
  }
  p {
    font-family: "Hind", sans-serif;
    font-weight: normal;
    line-height: 1.8;
    font-size: 1.25rem;
    color: var(--text-color);
    margin-top: 32px;
  }
`;
